import React, { PureComponent } from 'react';
import { Table, Button, Popup, Loader, Icon } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import CopyToClipboard from 'react-copy-to-clipboard';
import EditShareIframeModal from './EditShareIframeModal';

class InsightsListItem extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showEditShareIframeModal: false
    };
  }

  expireTooltip = (expiration) => {
    let message = "Add 7 days to expiration. You can't add more than 30 days";

    const expirationDate = new Date(expiration);
    expirationDate.setDate(expirationDate.getDate() + 1);

    const today = new Date();
    today.setDate(today.getDate() + 30);

    const diffDays =
      parseInt((today - expirationDate) / (1000 * 60 * 60 * 24), 10) + 1;

    if (expirationDate.getDate() === today.getDate() || diffDays < 0) {
      message = "You can't add more than 30 days";
    } else if (diffDays < 7) {
      message = `Add ${diffDays} days to expiration`;
    }

    return message;
  };

  isUpdateExpirationEnabled = (expiration) => {
    const expiredAt = new Date(expiration);
    expiredAt.setDate(expiredAt.getDate() + 1);

    const today = new Date();
    today.setDate(today.getDate() - 1);

    const monthFromToday = new Date();
    monthFromToday.setDate(monthFromToday.getDate() + 30);

    const diffDays =
      parseInt((monthFromToday - expiredAt) / (1000 * 60 * 60 * 24), 10) + 1;

    return expiredAt.getDate() !== today.getDate() && diffDays > 0;
  };

  toggleEditShareIframeModal = () => {
    const { showEditShareIframeModal } = this.state;
    this.setState({ showEditShareIframeModal: !showEditShareIframeModal });
  };

  openEditShareIframeModalButton = (
    <Button onClick={this.toggleEditShareIframeModal} size="small" color="blue">
      Edit
    </Button>
  );

  saveEditedIframe = async (updatedIframe) => {
    const { updateIframe } = this.props;
    const updateIframeStatusCode = await updateIframe(updatedIframe);
    if (updateIframeStatusCode === 200) {
      toast.success(`Insights Preview Link Details successfully updated.`, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } else {
      toast.error(`Failed to save.`, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };

  render() {
    const { showEditShareIframeModal } = this.state;
    const {
      iframe,
      path,
      copied,
      refreshExpiration,
      refreshingExpirationIds,
      showConfirm,
      deleteRowId,
      onCopy,
      showDashboards,
      mouseEnter,
      mouseLeave,
      updateExpiration,
      handleConfirm,
      handleCancel,
      openDialog
    } = this.props;
    const {
      id: iframeId,
      url: iframeUrl,
      date: iframeDate,
      dashboards: iframeDashboards,
      username: iframeUsername,
      created_at: createdAt,
      account: iframeAccount,
      updated_at: updatedAt,
      expired_at: expiredAt,
      isPrivate
    } = iframe;
    const shareUrl = `${path}/insightsPreview/detail/${iframeUrl}`;
    return (
      <Table.Row key={iframeId}>
        <Table.Cell>
          <CopyToClipboard text={shareUrl} onCopy={onCopy}>
            {iframeAccount ? (
              <a className="link-presentation">{iframeAccount}</a>
            ) : (
              <span>
                No accounts selected{' '}
                <a className="link-presentation">{shareUrl}</a>
              </span>
            )}
          </CopyToClipboard>
          {isPrivate && (
            <Popup
              basic
              trigger={<Icon name="lock" color="green" />}
              content="This link requires a password in order for its contents to be viewed"
            />
          )}
          {copied === iframeUrl ? (
            <div className="div-expires">
              <span>Copied</span>
            </div>
          ) : null}
        </Table.Cell>
        <Table.Cell>{iframeDate}</Table.Cell>
        <Table.Cell>{showDashboards(iframeDashboards)}</Table.Cell>
        <Table.Cell>{iframeUsername}</Table.Cell>
        <Table.Cell>
          {new Date(Date.parse(createdAt)).toLocaleString('en-us', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          })}
        </Table.Cell>
        <Table.Cell>
          {new Date(Date.parse(updatedAt)).toLocaleString('en-us', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
          })}
        </Table.Cell>
        <Table.Cell
          className="expired-td"
          id={iframeId}
          onMouseEnter={mouseEnter}
          onMouseLeave={mouseLeave}
        >
          <div className="expired-wrapper">
            {expiredAt}
            {refreshExpiration === iframeId &&
            !refreshingExpirationIds.includes(iframeId) ? (
              <div className="text-expires-update">
                {this.isUpdateExpirationEnabled(expiredAt) ? (
                  <Popup
                    trigger={
                      <i
                        tabIndex="0"
                        role="button"
                        className="refresh icon"
                        onClick={() => updateExpiration(iframe)}
                      />
                    }
                    content={this.expireTooltip(expiredAt)}
                  />
                ) : (
                  <Popup
                    trigger={<i className="refresh icon greyed" />}
                    content={this.expireTooltip(expiredAt)}
                  />
                )}
              </div>
            ) : null}
            {refreshingExpirationIds.includes(iframeId) ? (
              <div className="spinner-expires">
                <Loader inline className="active" size="mini" />
              </div>
            ) : null}
          </div>
        </Table.Cell>
        <Table.Cell className="col-confirm">
          {showConfirm && iframeId === deleteRowId ? (
            <div className="div-confirm">
              <p className="text-confirm">Are you sure?</p>
              <Button onClick={handleConfirm} size="mini" color="grey">
                Yes
              </Button>
              <Button onClick={handleCancel} size="mini" color="red">
                No
              </Button>
            </div>
          ) : (
            <div className="div-confirm">
              <EditShareIframeModal
                iframe={iframe}
                shareUrl={shareUrl}
                showEditShareIframeModal={showEditShareIframeModal}
                openEditShareIframeModalButton={
                  this.openEditShareIframeModalButton
                }
                toggleEditShareIframeModal={this.toggleEditShareIframeModal}
                saveEditedIframe={this.saveEditedIframe}
              />
              <br />
              <br />
              <Button
                data={{ id: iframeId }}
                onClick={openDialog}
                size="small"
                color="blue"
              >
                Delete
              </Button>
            </div>
          )}
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default InsightsListItem;



// WEBPACK FOOTER //
// ./src/screens/InsightsPreview/InsightsListItem.js